import { render, staticRenderFns } from "./DeviceReceived.vue?vue&type=template&id=6945bef4&"
import script from "./DeviceReceived.vue?vue&type=script&lang=js&"
export * from "./DeviceReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports